import { type JanusCtx, type Row, handBack, itemField, requiredInt, record } from './context.js';
import { statCreature } from './summon-caster-cantrips.js';

/** includes/functions/janus/core/check_scalable_cantrip.php:check_scalable_cantrip — `layer_value($caster_arr, 'total_level')`
 * (bridged to computed.creature.meta.total_level). Only a PLAYER CHARACTER compile sets it; a creature caster reads null, and
 * PHP's `null >= 9` is false → no scaling. Null on a row whose compile is not held stays a hand-back (unknown, not zero). */
export function checkScalableCantrip(ctx: JanusCtx, ability: Row, castingCreature: Row, dice: number): number {
  if (!ctx.read.has(ability, 'spell_scalable_cantrip')) return dice;
  // summons_gain_caster_cantrips: a summon's injected cantrip scales with its CONTROLLER's level ("use your … damage")
  const caster = statCreature(ctx, castingCreature, itemField(ability, 'item_id'));
  const raw = ctx.read.value(caster, 'total_level') ?? record(record(record(caster.computed)?.creature)?.meta)?.total_level;
  let level = 0;
  if (raw == null) {
    if (!record(record(caster.computed)?.creature)) handBack('check_scalable_cantrip:level-not-held');
    if (record(caster.player_characters)) handBack('check_scalable_cantrip:pc-level-not-held');
  } else level = requiredInt(raw, 'check_scalable_cantrip:level-not-held');
  return dice + (level >= 33 ? 3 : level >= 19 ? 2 : level >= 9 ? 1 : 0);
}
